<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditSubDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editDepartment"
          class="fixed center-h-v bg-white rounded-md h-full md:h-auto shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Department</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-2 p-4 gap-5">
            <div class="grid grid-cols-2 gap-5 items-center">
              <div class="text-sm col-span-2">
                <label class="block pb-1 text-xs">Sub Department Name</label>
                <input
                  type="text"
                  name="SubDepartmentName"
                  v-model="subDepartmentToEdit.SubDepartmentName"
                  id=""
                  class="p-2 bg-gray-200 rounded-full w-full"
                  autofocus
                />
              </div>
            </div>

            <!-- <div class="grid grid-cols-2 gap-5 items-center">
              <div class="text-sm col-span-2">
                <label class="block pb-1 text-xs">Sub Department Manager</label>
                <input type="text" name="SubDepartmentManager" v-model="subDepartmentToEdit.SubDepartmentManager" id=""
                  class="p-2 bg-gray-200 rounded-full w-full" />
              </div>

            </div> -->

            <div class="grid grid-cols-1 p-4 gap-5">
              <div class="text-sm col-span-2">
                <label class="block pb-1">Department Manager</label>

                <el-select
                  v-model="subDepartmentToEdit.SubDepartmentManagerId"
                  class="w-full"
                >
                  <el-option
                    :label="jobTitle.Name"
                    :value="jobTitle.Id"
                    v-for="jobTitle in jobTitles"
                    :key="jobTitle.Id"
                  >
                    {{ jobTitle.Name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 
              <div class="grid grid-cols-2 gap-5 items-center">
                <div class="text-sm col-span-2">
                  <label class="block pb-1 text-xs">Company</label>
                  <input type="text" name="location" v-model="subDepartmentToEdit.LocationName" id=""
                    class="p-2 bg-gray-200 rounded-full w-full" />
                </div>

              </div> -->
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupEditSubDepartment",
  props: ["showEditSubDepartment", "subDepartmentToEdit", "reload"],
  components: { Loader },
  data() {
    return {
      managerId: "",
      saved_locations: [],
      employees: [],
      locations: [],
      jobTitles: [],
      info: {
        Name: null,
      },

      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },
  created() {
    this.getLocations();
    this.getEmployees();
    this.getJobTitles();
    // //console.log(this.employees);
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  watch: {
    showEditSubDepartment(newState) {
      if (newState) {
        this.getJobTitles();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // /{organization}/setup/location/v1/request
    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.locations = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/department/{departmentId}/sub-departments/v1/edit
    editDepartment() {
      this.loading = true;

      // const { DepartmentId } = this.subDepartmentToEdit;
      // this.subDepartmentToEdit['']
      // //console.log(this.locations.map(location => //console.log(location)))
      // const locationId = this.locations.find(location => location.Name.trim().toLowerCase() === this.subDepartmentToEdit.Location.trim().toLowerCase()).Id
      this.subDepartmentToEdit["Name"] =
        this.subDepartmentToEdit.SubDepartmentName;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/department/subdepartment/${this.$ApiVersion}/edit`,
          JSON.stringify(this.subDepartmentToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.close();
                this.reload();
              }, 2000);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },

    getJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.jobTitles = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    async fetchDepartmentManagers(queryString, callback) {
      // fetch departments
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        callback(this.employees);
      } else {
        callback(this.employees);
      }
    },
    findDepartmentManagers(manager) {
      this.subDepartmentToEdit.SubDepartmentManagerId = manager.Id;
    },
    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          //console.log(response.data)
          this.employees = response.data.Data;
          //console.log(this.employees)
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
